import { InteractionDefintion } from "../interaction_picker/InteractionDefinitions";
import { useInteractionPickerIcons } from "../interaction_picker/InteractionPickerIconHooks";
import classNames from "classnames";
import React, { useEffect } from "react";

export default function InteractionContextMenuItem(props: {
  interactionDefinition: InteractionDefintion;
  isSelected: boolean;
  onSelect: (definition: InteractionDefintion) => void;
  propInstanceId?: string;
}) {
  const { interactionDefinition, isSelected, onSelect } = { ...props };
  const [getIcon] = useInteractionPickerIcons();
  const ref = React.useRef<HTMLDivElement>(null);

  const icon = getIcon(interactionDefinition);

  useEffect(() => {
    if (!isSelected || !ref.current) return;

    ref.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  }, [isSelected]);

  return (
    <div
      className={classNames(
        "box-content flex items-center whitespace-nowrap cursor-pointer text-ellipsis gap-[8px] hover:bg-creator-primary-washed hover:outline-none z-[10000] px-[8px] py-[2px] rounded-[5px]",
        {
          "border-2 border-solid border-creator-primary rounded-[5px] text-creator-primary bg-creator-primary-washed":
            isSelected,
          "bg-creator-surface": !isSelected,
        }
      )}
      onClick={() => onSelect(interactionDefinition)}
      ref={ref}
    >
      <div className="text-[22px]">{icon}</div>
      <div className="w-full text-[14px]">{interactionDefinition.name}</div>
    </div>
  );
}
